import { createSlice } from '@reduxjs/toolkit';

const schedule = createSlice({
    name: 'schedule',
    initialState: {
        day: '',
        sites: [],
    },
    reducers: {
        setDay: (state, action) => {
            state.day = action.payload;
        },
        setSites: (state, action) => {
            state.sites = action.payload;
        },
    },
});
export const { setDay,setSites } = schedule.actions;
export default schedule.reducer;
